var app = angular.module("leonardo");

var ReportsWorkOrdersFilters = function (
  $scope,
  $controller,
  $rootScope,
  $timeout,
  $state,
  ReportService,
  WorkOrderService,
  WorkOrderCVService,
  UnitService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersWorkOrders;
  $scope.fieldsReport = ReportService.fieldsReportWorkOrder;

  $scope.group_options.push({ id: 'managed_by', name: 'Managed By' });

  $scope.filters_options = [];

  $scope.initOptions = function() {

    $scope.filters_base = $scope.filters_base.filter(function (filter) { return filter.group != 'due_date' });

    $scope.filters_options = $scope.filters_base.concat([
      {
        group: 'created_date',
        name: 'Created Date',
        elements: [
          {
            id: 'created_from_date',
            name: 'Created Date From',
            label: 'Created Date From',
            inline: false,
            type: 'date',
            placeholder: 'Created Date From',
            condition: true,
            conflicts: [],
            positionVertical: 'bottom',
            endDate: 'created_to_date'
          },
          {
            id: 'created_to_date',
            name: 'Created Date To',
            label: 'Created Date To',
            inline: false,
            type: 'date',
            placeholder: 'Created Date To',
            condition: true,
            conflicts: [],
            positionVertical: 'bottom',
            startDate: 'created_from_date'
          },
          {
            id: 'created_date_range',
            name: 'Created Dates Range',
            label: 'Created Dates Range',
            inline: false,
            type: 'date_range',
            placeholder: 'Created Dates Range',
            condition: true,
            conflicts: [],
            startDate: 'created_from_date',
            endDate: 'created_to_date'
          }
        ]
      },
      {
        group: 'due_date',
        name: 'Due Date',
        elements: [
          {
            id: 'from_date',
            name: 'Due Date From',
            label: 'Due Date From',
            inline: false,
            type: 'date',
            placeholder: 'Due Date From',
            condition: true,
            conflicts: [],
            positionVertical: 'bottom',
            endDate: 'to_date'
          },
          {
            id: 'to_date',
            name: 'Due Date To',
            label: 'Due Date To',
            inline: false,
            type: 'date',
            placeholder: 'Due Date To',
            condition: true,
            conflicts: [],
            positionVertical: 'bottom',
            startDate: 'from_date'
          },
          {
            id: 'date_range',
            name: 'Due Dates Range',
            label: 'Due Dates Range',
            inline: false,
            type: 'date_range',
            placeholder: 'Due Dates Range',
            condition: true,
            conflicts: [],
            startDate: 'from_date',
            endDate: 'to_date'
          }
        ]
      },
      {
        id: 'name',
        name: 'Brief Description',
        label: 'Brief Description Contains',
        inline: false,
        type: 'text',
        placeholder: 'Brief Description',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'priority',
        name: 'Priority',
        label: 'Priority',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Priorities',
        condition: true,
        service: WorkOrderCVService,
        serviceParams: {type: 0},
        conflicts: []
      },
      {
        id: 'category',
        name: 'Category',
        label: 'Category',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Categories',
        condition: true,
        service: WorkOrderCVService,
        serviceParams: {type: 2},
        conflicts: []
      },
      {
        id: 'status',
        name: 'Status',
        label: 'Status',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Status',
        condition: true,
        service: WorkOrderCVService,
        serviceParams: {type: 1},
        conflicts: []
      },
      {
        id: 'type',
        name: 'Type',
        label: 'Type',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Type',
        condition: true,
        options: WorkOrderService.TYPE_OPTIONS,
        conflicts: []
      },
      {
        id: 'action_item__due_date',
        name: 'Due Date',
        label: 'Due Date',
        inline: false,
        type: 'date',
        placeholder: 'Due Date',
        condition: true,
        conflicts: [],
        positionVertical: 'bottom'
      },
      {
        id: 'completed_date',
        name: 'Completed Date',
        label: 'Completed Date',
        inline: false,
        type: 'date',
        placeholder: 'Completed Date',
        condition: true,
        conflicts: [],
        positionVertical: 'bottom'
      },
      {
        id: 'service_request_date',
        name: 'Created Date',
        label: 'Created Date',
        inline: false,
        type: 'date',
        placeholder: 'Created Date',
        condition: true,
        conflicts: [],
        positionVertical: 'bottom'
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: $scope.fieldsReport,
        conflicts: []
      },
      {
        id: 'unit_number',
        name: 'Unit',
        label: 'Unit',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Unit',
        condition: true,
        service: UnitService,
        serviceFunction: UnitService.getAllByProperty,
        conflicts: []
      },
      {
        id: 'building',
        name: 'Building Number',
        label: 'Building Number',
        inline: false,
        type: 'text',
        placeholder: 'Building number',
        condition: true,
        onSubmit: $scope.display,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $scope.$on('fields-report:updated', function (event, fields) {
    $scope.fieldsReport = fields;
  });

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    // Check if we're on the work order activity report based on the state
    const isWorkOrderActivity = $state.current.name === 'reports.work-order-activity';
    $rootScope.$broadcast('report-type:updated', isWorkOrderActivity ? 
      ReportService.TYPE_WORK_ORDER_ACTIVITY : ReportService.TYPE_WORK_ORDERS);
  }, 100);

};

app.controller('ReportsWorkOrdersFilters', [
  '$scope',
  '$controller',
  '$rootScope',
  '$timeout',
  '$state',
  'ReportService',
  'WorkOrderService',
  'WorkOrderCVService',
  'UnitService',
  ReportsWorkOrdersFilters
]);
